import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql-types'

const defaultOptions = {} as const
export type OnboardingChatSubscriptionSubscriptionVariables = Types.Exact<{
  input: Types.OracleAgentChatInput;
}>;

export type OnboardingChatSubscriptionSubscription = { __typename?: 'Subscription', oracleAgentChat: { __typename?: 'OracleAgentChatSubscriptionPayload', chatSessionId?: string | null, messagePairId?: string | null, textChunk?: string | null, error?: string | null, success: boolean, sessionTitle?: string | null, isFinal: boolean, chatChannel?: string | null, errorInfo: Array<{ __typename?: 'AppError', code: string, message: string }>, clientSignals?: Array<{ __typename?: 'ClientSignal', type: string, payload?: unknown | null }> | null } };

export const OnboardingChatSubscriptionDocument = gql`
    subscription OnboardingChatSubscription($input: OracleAgentChatInput!) {
  oracleAgentChat(input: $input) {
    chatSessionId
    messagePairId
    textChunk
    error
    success
    errorInfo {
      code
      message
    }
    sessionTitle
    isFinal
    chatChannel
    clientSignals {
      type
      payload
    }
  }
}
    `

/**
 * __useOnboardingChatSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOnboardingChatSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingChatSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingChatSubscriptionSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingChatSubscriptionSubscription (baseOptions: Apollo.SubscriptionHookOptions<OnboardingChatSubscriptionSubscription, OnboardingChatSubscriptionSubscriptionVariables> & ({ variables: OnboardingChatSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<OnboardingChatSubscriptionSubscription, OnboardingChatSubscriptionSubscriptionVariables>(OnboardingChatSubscriptionDocument, options)
}
export type OnboardingChatSubscriptionSubscriptionHookResult = ReturnType<typeof useOnboardingChatSubscriptionSubscription>;
export type OnboardingChatSubscriptionSubscriptionResult = Apollo.SubscriptionResult<OnboardingChatSubscriptionSubscription>;
